<template>
  <div class="filters-container">
    <!-- Filtros principales -->
    <div class="row g-3">
      <div class="col-lg-2 col-md-6">
        <label for="userIdFilter" class="form-label fw-semibold">
          <i class="fas fa-hashtag text-secondary me-1"></i>
          Por ID
        </label>
        <SoftInput
          size="sm"
          id="userIdFilter"
          type="number"
          :value="userId"
          @update:value="$emit('update:userId', $event)"
          placeholder="ID usuario..."
        />
      </div>

      <div class="col-lg-2 col-md-6">
        <label for="nameFilter" class="form-label fw-semibold">
          <i class="fas fa-user text-secondary me-1"></i>
          Por Nombre
        </label>
        <SoftInput
          size="sm"
          id="nameFilter"
          :value="nameAgent"
          @update:value="$emit('update:nameAgent', $event)"
          placeholder="Buscar por nombre..."
        />
      </div>

      <div class="col-lg-2 col-md-6">
        <label for="emailFilter" class="form-label fw-semibold">
          <i class="fas fa-envelope text-secondary me-1"></i>
          Por Correo
        </label>
        <SoftInput
          type="email"
          id="emailFilter"
          size="sm"
          :value="email"
          @update:value="$emit('update:email', $event)"
          placeholder="Buscar por correo..."
        />
      </div>

      <div class="col-lg-2 col-md-6">
        <label for="cedulaFilter" class="form-label fw-semibold">
          <i class="fas fa-id-card text-secondary me-1"></i>
          Por Cédula
        </label>
        <SoftInput
          size="sm"
          id="cedulaFilter"
          :value="cedula"
          @update:value="$emit('update:cedula', $event)"
          placeholder="Buscar por cédula..."
        />
      </div>

      <div class="col-lg-3 col-md-6">
        <label class="form-label fw-semibold">
          <i class="fas fa-user-tag text-secondary me-1"></i>
          Por Rol
        </label>
        <VSelect
          :options="roles"
          :modelValue="role"
          @update:modelValue="$emit('update:role', $event)"
          label="nombre"
          :reduce="roleItem => roleItem.id"
          placeholder="Seleccionar rol..."
          :clearable="true"
          class="filter-select"
        >
          <template #no-options>
            <div class="text-muted p-2 text-center small">
              No hay roles disponibles
            </div>
          </template>
        </VSelect>
      </div>

      <div class="col-lg-3 col-md-6">
        <label class="form-label fw-semibold">
          <i class="fas fa-crown text-secondary me-1"></i>
          Por Membresía
        </label>
        <VSelect
          :options="memberships_plans"
          :modelValue="membership"
          @update:modelValue="$emit('update:membership', $event)"
          label="code"
          :reduce="mem => mem.id"
          placeholder="Seleccionar membresía..."
          :clearable="true"
          class="filter-select"
        >
          <template #no-options>
            <div class="text-muted p-2 text-center small">
              No hay membresías disponibles
            </div>
          </template>
        </VSelect>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="actions-row">
      <div class="d-flex gap-2 flex-wrap align-items-center">
        <SoftButton color="primary" size="sm" variant="gradient" @click="$emit('search')">
          <i class="fas fa-search me-1"></i>
          Buscar
        </SoftButton>

        <SoftButton color="secondary" size="sm" variant="outline" @click="$emit('clear')">
          <i class="fas fa-broom me-1"></i>
          Limpiar
        </SoftButton>

        <SoftButton color="secondary" size="sm" variant="outline" @click="$emit('refresh')">
          <i class="fas fa-sync-alt me-1"></i>
          Actualizar
        </SoftButton>

        <span v-if="hasActiveFilters" class="badge bg-primary bg-gradient ms-2">
          <i class="fas fa-filter me-1"></i>
          {{ activeFiltersCount }} filtro{{ activeFiltersCount > 1 ? 's' : '' }}
        </span>

        <!-- Slot para botones adicionales -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import SoftInput from '@/components/SoftInput.vue'
import SoftButton from '@/components/SoftButton.vue'

export default {
  name: 'FiltersComponent',
  components: {
    SoftInput,
    SoftButton
  },
  props: {
    userId: {
      type: [String, Number],
      default: null
    },
    nameAgent: {
      type: String,
      default: null
    },
    email: {
      type: String,
      default: null
    },
    cedula: {
      type: String,
      default: null
    },
    role: {
      type: [String, Number],
      default: null
    },
    membership: {
      type: [String, Number],
      default: null
    },
    roles: {
      type: Array,
      default: () => []
    },
    memberships_plans: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    'update:userId',
    'update:nameAgent',
    'update:email',
    'update:cedula',
    'update:role',
    'update:membership',
    'search',
    'clear',
    'refresh'
  ],
  computed: {
    hasActiveFilters() {
      return !!(this.userId || this.nameAgent || this.email || this.cedula || this.role || this.membership);
    },
    activeFiltersCount() {
      let count = 0;
      if (this.userId) count++;
      if (this.nameAgent) count++;
      if (this.email) count++;
      if (this.cedula) count++;
      if (this.role) count++;
      if (this.membership) count++;
      return count;
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-container {
  background: #F8FAFC;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 0;
  border: 1px solid #E2E8F0;

  .form-label {
    margin-bottom: 5px;
    color: #475569;
    font-size: 0.75rem;
    font-weight: 600;
  }
}

.filter-select {
  :deep(.vs__dropdown-toggle) {
    border: 1px solid #CBD5E1;
    border-radius: 6px;
    min-height: 34px;
    background: #fff;
    font-size: 0.82rem;

    &:hover { border-color: #94A3B8; }
  }

  :deep(.vs__dropdown-toggle:focus-within) {
    border-color: #93C5FD;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  }

  :deep(.vs__search::placeholder) { color: #94A3B8; }

  :deep(.vs__dropdown-menu) {
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    border: 1px solid #E2E8F0;
    margin-top: 3px;
    font-size: 0.82rem;
  }

  :deep(.vs__dropdown-option--highlight) {
    background: #2563EB;
    color: #fff;
  }

  :deep(.vs__clear:hover) { color: #2563EB; }
}

.actions-row {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #E2E8F0;
}
</style>
